import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useMaxStockNum } from "./hooks";

export const QuestionMaxStockNum = () => {
	const { maxStockNum, onSetMaxStockNum } = useMaxStockNum();

	const title = "通算で提供できる合計発行枚数の上限";
	const guide =
		"宿泊券を提供できる通算の枚数に上限がある場合はここに入力してください。<br />入力しなかった場合は上限なしで購入可能になります。";

	return (
		<QuestionForMain
			required={false}
			title={title}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<p>通算</p>
					<InputNumberField
						value={maxStockNum?.value ?? undefined}
						handleInput={onSetMaxStockNum}
						errorMessage={maxStockNum?.error}
						hiddenSpinButton={false}
					/>
					<p>枚まで発行可能</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionMaxStockNum.displayName = "QuestionMaxStockNum";
